import { makeStyles, Theme } from '@material-ui/core';
import colors, { gallery2, pink } from 'constants/colors';

export const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    margin: '20px 70px 80px 30px',
    position: 'relative',
    padding: '10px 20px 10px 60px',
    [theme.breakpoints.down('sm')]: {
      margin: '0',
      padding: 0,
    },
  },
  contentWrapper: {
    width: '52%',
    minHeight: 670,
    background: colors.background,
    borderRadius: 25,
    zIndex: 0,
    [theme.breakpoints.down('sm')]: {
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      width: '100%',
      minHeight: 550,
      position: 'relative',
    },
  },
  content: {
    zIndex: 1,
    position: 'relative',
  },
  header: {
    height: 100,
    paddingLeft: 40,
    paddingRight: 0,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      paddingRight: 40,
    },
    [theme.breakpoints.down('xs')]: {
      paddingRight: 10,
      paddingLeft: 10,
    },
  },
  menu: {
    display: 'flex',
    alignItems: 'center',
  },
  connectBtnPadding: { padding: '13px 12px 13px 24px' },
  connectBtn: {
    minWidth: 160,
    paddingLeft: 20,
    '& svg': {
      marginLeft: 8,
    },
  },
  imgLogo: {
    width: 56,
  },
  bodyWrapper: {
    display: 'flex',
    width: '100%',
    maxWidth: 1440,
    margin: '0 auto',
    position: 'absolute',
    top: 50,
    left: 0,
    right: 0,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      top: 160,
    },
    [theme.breakpoints.down('xs')]: {
      top: 100,
    },
  },
  bodyContent: {
    width: '100%',
    maxWidth: 440,
    display: 'flex',
    flexDirection: 'column',
    margin: '60px 84px 0 65px',
    [theme.breakpoints.down('lg')]: {
      maxWidth: 200,
      textAlign: 'left',
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: 600,
      flexDirection: 'row',
      margin: '0 auto',
      textAlign: 'left',
    },
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      textAlign: 'center',
      maxWidth: 300,
    },
  },
  title: {
    display: 'flex',
    flexDirection: 'column',
  },
  desc: {
    '& p': {
      marginTop: 24,
      marginLeft: 0,
      fontSize: 16,
      fontFamily: 'Montserrat-Regular',
      lineHeight: 1.73,
      letterSpacing: 'normal',
      [theme.breakpoints.down('lg')]: {
        marginTop: 0,
      },
      [theme.breakpoints.down('md')]: {
        marginLeft: 40,
      },
      [theme.breakpoints.down('xs')]: {
        marginLeft: 0,
        fontSize: 14,
      },

      [theme.breakpoints.up('md')]: {
        marginLeft: 0,
        fontSize: 14,
      },
      [theme.breakpoints.up('xl')]: {
        fontSize: 16,
      },
    },
  },
  watermark: {
    color: gallery2,
    transform: 'rotate( -90deg) translate(100%, 0)',
    transformOrigin: 'right bottom',
    textTransform: 'uppercase',
    position: 'absolute',
    right: -70,
    bottom: 0,
    letterSpacing: 3,
    fontSize: 43,
    fontFamily: 'Mashine-Bold',
    opacity: 0.4,
  },
  titleBlack: {
    fontFamily: 'Mashine-Bold',
    fontSize: 70,
    lineHeight: 1.05,
    [theme.breakpoints.down('lg')]: {
      fontSize: 45,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 40,
    },
  },
  titlePink: {
    fontFamily: 'Mashine-Bold',
    fontSize: 70,
    color: pink,
    lineHeight: 1.05,
    [theme.breakpoints.down('lg')]: {
      fontSize: 45,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 40,
    },
  },
  connectWallet: {
    fontFamily: 'Mashine-Bold',
    fontSize: 20,
    color: pink,
    lineHeight: 1.05,
    textDecoration: 'underline',
    marginTop: 28,
    cursor: 'pointer',
    [theme.breakpoints.down('lg')]: {
      display: 'none',
    },
  },
  blockStatistic: {
    maxWidth: 1248,
    width: '100%',
    margin: '40px auto 0',
    [theme.breakpoints.down('sm')]: {
      padding: '20px 50px',
      margin: '0',
    },
  },
  blockCards: {
    maxWidth: 600,
    [theme.breakpoints.down('lg')]: {
      maxWidth: '100%',
      padding: '0 50px',
    },
    // padding: 20,
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    '& button:first-child': { marginRight: 8 },
    '& button:last-child': { marginLeft: 8 },
  },
  uniActions: {
    '& button:nth-child(2)': { marginRight: 8 },
  },
  btn: {
    width: '100%',
    maxWidth: 120,
    height: 50,
  },
  spinner: {
    color: '#fff',
  },
  link: {
    color: pink,
    fontWeight: 'bold',
  },
  tokenInfoContainer: {
    height: 'fit-content',
    paddingBottom: '0 !important',
  },
}));
